import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './guards/auth-guard.service';
import { LoginRedirectGuard } from './guards/login-redirect.guard';
import { BrandingSettingsResolver } from '@resolvers/branding-settings.resolver';
import { SpeechSettingsResolver } from '@resolvers/speech-settings.resolver';

const ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('@login/login.component').then(m => m.LoginComponent),
    canActivate: [LoginRedirectGuard],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./observation/observation.module').then(m => m.ObservationModule),
    canActivate: [AuthGuardService],
    resolve: {
      userBrandingSettings: BrandingSettingsResolver,
      userSpeechSettings: SpeechSettingsResolver,
    },
  },
  {
    path: 'should-login',
    loadComponent: () =>
      import('./should-login/should-login.component').then(
        m => m.ShouldLoginComponent
      ),
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./not-found/not-found.component').then(m => m.NotFoundComponent),
    canActivate: [AuthGuardService],
    resolve: { userBrandingSettings: BrandingSettingsResolver },
  },
  {
    path: '**',
    loadComponent: () =>
      import('./not-found/not-found.component').then(m => m.NotFoundComponent),
    canActivate: [AuthGuardService],
    resolve: { userBrandingSettings: BrandingSettingsResolver },
  },
];

export const AppRouter = RouterModule.forRoot(ROUTES, {
  onSameUrlNavigation: 'ignore',
});
